import { usePageTitle } from '@app/hooks/usePageTitle';
import TokenBuysWidget from '@widgets/trades/token-buys';

const TokenBuysPage = () => {
  usePageTitle('Token Buy');

  return <TokenBuysWidget />;
};

export default TokenBuysPage;
